import Table from '@tiptap/extension-table';

export const CustomTable = Table.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      customStyle: {
        default: null,
        renderHTML: () => {
          return {
            style:
              'border-collapse: collapse; width: 100%; margin: 0;white-space:nowrap; overflow-x: scroll;',
          };
        },
      },
    };
  },
}).configure({
  resizable: true,
});
